module.exports = __webpack_public_path__ + "static/media/U-Capture.7ca66d6e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/backgrounds/U-Capture.jpg
// module id = 439
// module chunks = 0